import { useState, useRef, useEffect } from 'react';
import '../../Utils/assets/css/table.css';
import { Button, Offcanvas, Card, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import '../../Utils/assets/css/table.css';

const colourOptions = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' }
]

export const Enquiry = () => {
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);

  const [activePanel, setActivePanel] = useState(false);
  const [selectedIndexes, setSelectedIndexes] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const tbodyRef = useRef(null);

  useEffect(() => {
    // Dynamically count how many <tr> are inside <tbody>
    const count = tbodyRef.current?.querySelectorAll('tr').length || 0;
    setTotalRows(count);
  }, []);

  const allIndexes = Array.from({ length: totalRows }, (_, i) => i);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIndexes(allIndexes);
    } else {
      setSelectedIndexes([]);
    }
  };

  const handleSelectOne = (index) => {
    setSelectedIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };


  return (
    <>
      <div className='d-flex justify-content-between align-items-center' >
        <h1>
          All Leads
        </h1>
        <Button className="btn-default" onClick={() => setActivePanel("add")}>
          <i className='fa-solid fa-plus me-2'></i>  Add</Button>

      </div>
      <Card className="custom-card listCards">

        <div className=' justify-content-between align-items-center ' style={{ padding: "15px 10px", display: selectedIndexes.length > 0 ? 'flex' : 'none' }}>
          <div>
            <span> Selected <span className="boldText">{selectedIndexes.length}</span> enquiry
              {selectedIndexes.length > 1 ? 'ies' : 'y'} from{' '}
              <span className="boldText">{totalRows}</span></span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <Button className='btn-success-outline' style={styles.buttonsIcons}><i className="fa-brands fa-square-whatsapp fs-19"></i> WhatsApp</Button>
            <Button className='btn-secondary-outline' style={styles.buttonsIcons}><i className="fa-solid fa-comment-dots fs-19"></i> SMS</Button>
            <Button className='btn-default-outline' style={styles.buttonsIcons}><i className="fa-solid fa-share-from-square fs-16"></i> Assign</Button>
            <Button className='btn-danger-outline' style={styles.buttonsIcons}><i className="fa-solid fa-trash-can fs-16"></i> Delete</Button>

          </div>
        </div>
        <div className="table-responsive" style={{ borderRadius: '0 !important' }}>
          <table className={selectedIndexes.length > 0 ? 'showButtons table' : 'table'}>

            <thead>
              <tr>
                <th><input type="checkbox" className='form-check-input checkboxs' checked={selectedIndexes.length === totalRows && totalRows > 0} onChange={handleSelectAll} /></th>
                <th>Name</th>
                <th><div className='d-flex align-items-center justify-content-start'>Title <span className='ms-2' style={{
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '9px'
                }}>
                  <i class="fa-solid fa-caret-up" style={{ height: '4px' }}></i>
                  <i class="fa-solid fa-caret-down"></i>
                </span></div> </th>
                <th>Company</th>
                <th>Phone</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Lead Status</th>
                <th>Lead Owner</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody ref={tbodyRef}>
              <tr>
                <td><input type="checkbox" className='form-check-input checkboxs' checked={selectedIndexes.includes(0)} onChange={() => handleSelectOne(0)} /></td>
                <td style={{ color: '#536485', fontWeight: 600 }}>Ram Sawant</td>
                <td>System Administrator</td>
                <td>MedLife, Inc. </td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-phone-volume fs-14 me-2"></i>9021953381</td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-phone-volume fs-14 me-2"></i>9021953381</td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-envelope fs-14 me-2"></i>info@pugcrm.com</td>
                <td>Interested</td>
                <td>Madhav Pandey</td>
                <td>
                  <div className='btn-actions'>
                    <Button className='btn-light btn-sm'>
                      <i class="fa-solid fa-eye"></i>
                    </Button>
                    <Button className='btn-light btn-sm'>
                      <i class="fa-solid fa-trash-can"></i>
                    </Button>
                  </div>
                </td>
              </tr>
              <tr>
                <td><input type="checkbox" className='form-check-input checkboxs' checked={selectedIndexes.includes(1)} onChange={() => handleSelectOne(1)} /></td>
                <td style={{ color: '#536485', fontWeight: 600 }}>Ram Sawant</td>
                <td>System Administrator</td>
                <td>MedLife, Inc. </td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-phone-volume fs-14 me-2"></i>9021953381</td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-phone-volume fs-14 me-2"></i>9021953381</td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-envelope fs-14 me-2"></i>info@pugcrm.com</td>
                <td>Interested</td>
                <td>Madhav Pandey</td>
                <td>
                  <div className='btn-actions'>
                    <Button className='btn-light btn-sm'>
                      <i class="fa-solid fa-eye"></i>
                    </Button>
                    <Button className='btn-light btn-sm'>
                      <i class="fa-solid fa-trash-can"></i>
                    </Button>
                  </div>
                </td>
              </tr>
              <tr>
                <td><input type="checkbox" className='form-check-input checkboxs' checked={selectedIndexes.includes(2)} onChange={() => handleSelectOne(2)} /></td>
                <td style={{ color: '#536485', fontWeight: 600 }}>Ram Sawant</td>
                <td>System Administrator</td>
                <td>MedLife, Inc. </td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-phone-volume fs-14 me-2"></i>9021953381</td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-phone-volume fs-14 me-2"></i>9021953381</td>
                <td style={{ color: '#0250d9' }}><i class="fa-solid fa-envelope fs-14 me-2"></i>info@pugcrm.com</td>
                <td>Interested</td>
                <td>Madhav Pandey</td>
                <td>
                  <div className='btn-actions'>
                    <Button className='btn-light btn-sm'>
                      <i class="fa-solid fa-eye"></i>
                    </Button>
                    <Button className='btn-light btn-sm'>
                      <i class="fa-solid fa-trash-can"></i>
                    </Button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>

      <Offcanvas show={activePanel === "add"} onHide={() => setActivePanel(null)} placement="end" style={styles.addLeadOffcanvas} id="addLeadOffcanvas">
        <Offcanvas.Header closeButton className='border-bottom'>
          <div className="d-flex align-items-center">
            <span className="avatar avatar-md avatar-rounded bg-info-transparent me-2" style={{ fontSize: '16px', border: '1px solid #009efb !important', background: 'none !important' }}>
              <i class="fa-solid fa-user"></i></span>
            <div>
              <h5 id="offcanvasRightLabel" className=" fs-18 mb-0 addEnquiryHeadDiv" style={{ display: 'flex', flexDirection: 'column', color: '#3973fc !important' }}>
                <span className="addEnquiryHead fw-300 fs-19" style={{ color: '#536485' }}>Add Leads</span>
                <span className="addEnquiryText" style={{ color: '#727272', fontSize: '13px', fontWeight: 300, marginTop: '3px' }}>Add potential lead here, Fill all the mandatory fields before submitting the lead.</span>
              </h5>
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className='pt-0 pb-0'>
          <form
            id="leadsForm"
            action="##"
            method="POST"
            className="h-100"
            encType="multipart/form-data"
          >

            <div className="row h-100">
              <div
                className="left-section col-md-3 h-100 pt-3"
                style={{ borderRight: '1px solid #dee2e6', paddingRight: '0px' }}
              >
                <div style={{ position: 'sticky', top: '10px', paddingLeft: '18px !important' }}>
                  <ul style={{ listStyle: 'none', lineHeight: '2.5rem', color: 'rgb(142 150 161)' }}>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#generalInformation" className="navLinksForparts">General Information</a></li>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#Communications" className="navLinksForparts">Communication</a></li>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#Locations" className="navLinksForparts">Location</a></li>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#Socials" className="navLinksForparts">Social</a></li>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#Professional" className="navLinksForparts">Bussiness Information</a></li>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#Requirment" className="navLinksForparts">Requirment</a></li>
                    <li style={{ cursor: 'pointer' }} className="hideUnrequired"><a href="#CompaignInformations" className="navLinksForparts">FollowUp Information</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-md-9 data-from h-100 pt-3">
                <h1 id="generalInformation" className="ms-2 fs-20 headingContent">General Information</h1>

                <Row className='ms-0 mt-3'>
                  <Col md={6} className="mb-3">
                    <label htmlFor="input-placeholder" className="form-label">Contact Name <sup>*</sup></label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={colourOptions[0]}
                      isDisabled={isDisabled}
                      isLoading={isLoading}
                      isClearable={isClearable}
                      isRtl={isRtl}
                      isSearchable={isSearchable}
                      name="color"
                      options={colourOptions}
                    />


                  </Col>
                  <Col md={6} className="mb-3">
                    <label htmlFor="input-placeholder" className="form-label">Contact Name <sup>*</sup></label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={colourOptions[0]}
                      isDisabled={isDisabled}
                      isLoading={isLoading}
                      isClearable={isClearable}
                      isRtl={isRtl}
                      isSearchable={isSearchable}
                      name="color"
                      options={colourOptions}
                    />


                  </Col>
                </Row>
                <div className=" d-flex justify-content-end align-items-center mt-4" style={styles.buttons}>
                  <Button
                    type="button"
                    data-bs-dismiss="offcanvas"
                    className=" btn-default-outline me-2"
                    onClick={() => setActivePanel(null)}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" className=" btn-default">Save</Button>
                </div>
              </div>


            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>


    </>
  )
}




const styles = {

  addLeadOffcanvas: {
    width: '74%',
    background: '#f9f9f9',

  },
  buttons: {
    position: 'absolute',
    bottom: '10px',
    right: '13px',
  },
  boldText: {
    fontWeight: 600,
    color: 'black',
  },
  buttonsIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  }
}